declare function require(path: string): any;

const pkg = require('../../package.json');
const buildVersion = pkg.version;

export const environment = {
  name: 'prod',
  production: true,
  authentication: {
    endpoint: undefined,
    userPoolId: 'us-east-1_u8hAgvBgX',
    clientId: '3nsdde6aes4f9ctjb44m0h15ai',
  },
  base_href: '/',
  publicBaseUrl: 'https://public.plowops.com/',
  adminBaseUrl: 'https://admin.plowops.com/',
  filesBaseUrl: 'https://files.prod.plowops.com/',
  services: {
    location: 'https://tracking.location-prod.neotreks.com/',
    service: 'https://api.prod.plowops.com/api/',
    lambda: 'https://api.prod.plowops.com/lambda/',
    cartegraph: 'https://api.prod.plowops.com/cartegraph/',
    plowopsWebsocket: 'wss://ws.prod.plowops.com',
    locationWebsocket: 'wss://tracking-ws.location-prod.neotreks.com',
  },
  version: buildVersion
};
